import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { 
  FaStar, 
  FaQuoteLeft, 
  FaUserGraduate,
  FaUserTie,
  FaChevronLeft,
  FaChevronRight
} from 'react-icons/fa';

const TestimonialsSectionCarousel = () => {
  const testimonials = [
    {
      name: "Rahul Sharma",
      role: "Parent of Class 8 Student",
      text: "The teachers are extremely dedicated and the infrastructure is excellent. My child has shown remarkable improvement.",
      rating: 5,
      type: "parent",
      image: "👨‍👦"
    },
    {
      name: "Priya Verma",
      role: "Alumni (Batch 2020)",
      text: "The foundation I got here helped me excel in my higher studies. Truly grateful for the holistic education.",
      rating: 5,
      type: "alumni",
      image: "👩‍🎓"
    },
    {
      name: "Dr. Arvind Singh",
      role: "Parent of LKG Student",
      text: "Safe environment and caring staff. My daughter loves going to school every day.",
      rating: 4,
      type: "parent",
      image: "👨‍⚕️"
    },
    {
      name: "Meena Patel",
      role: "Parent of Grade 5 Student",
      text: "Excellent co-curricular activities and attention to each child's needs. Highly recommended.",
      rating: 5,
      type: "parent",
      image: "👩‍👧"
    },
    {
      name: "Sanjay Gupta",
      role: "Parent of Class 10 Student",
      text: "Outstanding board preparation and career guidance. The teachers were exceptionally supportive.",
      rating: 5,
      type: "parent",
      image: "👨‍💼"
    }
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 640 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const CustomLeftArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute left-0 z-10 flex items-center justify-center w-10 h-10 text-gray-600 transition-all duration-300 transform -translate-y-1/2 bg-white border border-gray-300 rounded-full shadow-sm top-1/2 hover:bg-gray-50 hover:border-gray-400"
    >
      <FaChevronLeft className="w-4 h-4" />
    </button>
  );

  const CustomRightArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute right-0 z-10 flex items-center justify-center w-10 h-10 text-gray-600 transition-all duration-300 transform -translate-y-1/2 bg-white border border-gray-300 rounded-full shadow-sm top-1/2 hover:bg-gray-50 hover:border-gray-400"
    >
      <FaChevronRight className="w-4 h-4" />
    </button>
  );

  const getIconByType = (type) => {
    switch(type) {
      case 'parent': return <FaUserTie className="w-4 h-4" />;
      case 'alumni': return <FaUserGraduate className="w-4 h-4" />;
      default: return <FaUserTie className="w-4 h-4" />;
    }
  };

  const getColorByType = (type) => {
    switch(type) {
      case 'parent': return 'bg-blue-100 text-blue-600';
      case 'alumni': return 'bg-purple-100 text-purple-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <section className="py-8 bg-white">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto mb-10 text-center">
          <div className="inline-flex items-center px-3 py-1 mb-3 text-xs font-medium rounded-full text-amber-600 bg-amber-50">
            <FaStar className="w-3 h-3 mr-1.5" />
            Testimonials
          </div>
          <h2 className="mb-3 text-2xl font-bold text-gray-900">
            Voices of Trust
          </h2>
          <p className="text-sm text-gray-600">
            Hear from our parents and alumni about their experiences
          </p>
        </div>

        {/* Carousel Container */}
        <div className="relative px-8">
          <Carousel
            responsive={responsive}
            arrows
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
            showDots={true}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={4000}
            keyBoardControl={true}
            containerClass="carousel-container"
            itemClass="carousel-item-padding-40-px"
            dotListClass="custom-dot-list-style"
            className="pb-10"
          >
            {testimonials.map((testimonial, index) => (
              <div key={index} className="p-4">
                <div className="h-full p-5 transition-all duration-300 bg-white border border-gray-100 rounded-xl hover:shadow-sm">
                  {/* Quote Icon */}
                  <div className="mb-3">
                    <FaQuoteLeft className="w-6 h-6 text-blue-100" />
                  </div>

                  {/* Rating */}
                  <div className="flex items-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} className="w-4 h-4 mr-1 text-yellow-400" />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <p className="mb-6 text-sm italic leading-relaxed text-gray-600">
                    "{testimonial.text}"
                  </p>

                  {/* Author Info */}
                  <div className="flex items-center pt-4 border-t border-gray-100">
                    <div className="mr-3 text-2xl">
                      {testimonial.image}
                    </div>
                    
                    <div className="flex-1">
                      <div className="font-medium text-gray-900">{testimonial.name}</div>
                      <div className="text-xs text-gray-500">{testimonial.role}</div>
                    </div>

                    <div className={`inline-flex items-center justify-center w-8 h-8 rounded-full ${getColorByType(testimonial.type)}`}>
                      {getIconByType(testimonial.type)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Stats */}
        <div className="p-5 mt-8 border border-gray-100 bg-gradient-to-r from-gray-50 to-white rounded-xl">
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            <div className="text-center">
              <div className="text-lg font-bold text-gray-900">4.8/5</div>
              <div className="text-xs text-gray-600">Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-lg font-bold text-gray-900">98%</div>
              <div className="text-xs text-gray-600">Recommend</div>
            </div>
            <div className="text-center">
              <div className="text-lg font-bold text-gray-900">25+</div>
              <div className="text-xs text-gray-600">Years</div>
            </div>
            <div className="text-center">
              <div className="text-lg font-bold text-gray-900">1000+</div>
              <div className="text-xs text-gray-600">Families</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSectionCarousel;